import { render, staticRenderFns } from "./SeniorMemberReport.vue?vue&type=template&id=2240351c"
import script from "./SeniorMemberReport.vue?vue&type=script&lang=js"
export * from "./SeniorMemberReport.vue?vue&type=script&lang=js"
import style0 from "./SeniorMemberReport.vue?vue&type=style&index=0&id=2240351c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports